import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import RoomEdit             from "./RoomEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchRooms, deleteRoom,
} from "Actions/Admin/Location/RoomActions";



/**
 * The Location Room List
 */
class RoomList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchRooms(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteRoom(elemID);
        this.fetch();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, params, route, withDetails    } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "roomID", elemID, "name");

        return <Main withDetails={withDetails}>
            <Header message="ROOMS_NAME" icon="room" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="ROOMS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="name"             message="GENERAL_NAME"                    />
                        <TableHeader field="forStreches"      message="STRECHES_FOR_TEXT"               align="center" />
                        <TableHeader field="forConversations" message="LOCATIONS_FOR_CONVERSATIONS_TXT" align="center" />
                        <TableHeader field="forMeetings"      message="LOCATIONS_FOR_MEETINGS_TXT"      align="center" />
                        <TableHeader field="floor"            message="ROOMS_FLOOR"                     align="center" />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.roomID} elemID={elem.roomID}>
                            <TableCell message={elem.name}                   circle={elem.statusColor} />
                            <TableCell message={elem.forStrechesString}      />
                            <TableCell message={elem.forConversationsString} />
                            <TableCell message={elem.forMeetingsString}      />
                            <TableCell message={elem.floorName}              />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="ROOMS_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="ROOMS_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <RoomEdit
                open={action.isVCE}
                elemID={elemID}
                locationID={params.locationID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="ROOMS_DELETE_TITLE"
                message="ROOMS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchRooms  : PropTypes.func.isRequired,
        deleteRoom  : PropTypes.func.isRequired,
        data        : PropTypes.object.isRequired,
        type        : PropTypes.string.isRequired,
        params      : PropTypes.object.isRequired,
        route       : PropTypes.string.isRequired,
        withDetails : PropTypes.bool.isRequired,
        elemID      : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.locRoom,
        };
    }
}

export default connect(RoomList.mapStateToProps, {
    fetchRooms, deleteRoom,
})(RoomList);
